import axios from 'axios';

export const apiGetMilitaryInstallations = () => axios.get('/api/military-installations');
